import { useMemo } from "react";
import { DefaultButton, DirectionalHint, type IContextualMenuItem } from "@fluentui/react";
import { useNavigate } from "react-router-dom";

import { useAdminAccess } from "../../hooks/useAdminAccess";
import styles from "./AdminSettingsMenu.module.css";

export const AdminSettingsMenu = () => {
    const { isAdmin, isLoading } = useAdminAccess();
    const navigate = useNavigate();

    const menuItems: IContextualMenuItem[] = useMemo(
        () => [
            {
                key: "admin-console",
                text: "Admin Console",
                iconProps: { iconName: "Diagnostic" },
                onClick: () => {
                    navigate("/admin/dev-console");
                }
            }
        ],
        [navigate]
    );

    if (isLoading || !isAdmin) {
        return null;
    }

    return (
        <DefaultButton
            className={styles.menuButton}
            text="Settings"
            iconProps={{ iconName: "GlobalNavButton" }}
            aria-label="Open admin settings"
            menuProps={{
                items: menuItems,
                directionalHint: DirectionalHint.bottomRightEdge,
                calloutProps: { directionalHintFixed: true },
                useTargetWidth: true
            }}
        />
    );
};

export default AdminSettingsMenu;
